export const STOCK_COLLECTION = "stock";
export const BUSINESS_COLLECTION = "business";
export const PAYMENTS_COLLECTION = "payment-method";
export const SALES_COLLECTION = "sales";
export const SHIFT_COLLECTION = "shift";
export const CATEGORIES_COLLECTION = "categories";
export const USERS_COLLECTION = "users";
export const INGREDIENTS_COLLECTION = "ingredients"
export const PROMOTIONS_COLLECTION = "promotions"
// export const DAILY_COUNT_COLLECTION = "daily-count";

export const roles = [
  { value: "ADMIN", title: "Administrador" },
  { value: "CASHIER", title: "Caja" },
  { value: "KITCHEN", title: "Cocina" },
];

export const roleLabel: { [key: string]: string } = {
  ADMIN: "Administrador",
  CASHIER: "Caja",
  KITCHEN: "Cocina",
};

export const statusLabel: { [key: string]: string } = {
  pending: "Pendiente",
  preparing: "En preparación",
  ready: "Listo para entregar",
  completed: "Completado",
  cancelled: "Cancelado",
};

export const colorStatus: { [key: string]: any } = {
  pending: "warning",
  preparing: "primary",
  ready: "info",
  completed: "success",
  cancelled: "error",
};
